export default __webpack_public_path__ + "static/media/fiba.2b505203.jpg";